'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UICaret = require('../icon/icons/UICaret');

var _UICaret2 = _interopRequireDefault(_UICaret);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var TShirtSize = _interopRequireWildcard(_tshirtSize);

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _IconConstants = require('../icon/IconConstants');

var _AccordionTransition = require('../transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Inline style objects for deprecated `textElement` prop use case.
var indicatorCanvasStyle = {
  display: 'block',
  width: '100%',
  visibility: 'hidden'
};
var indicatorCaretStyle = {
  position: 'absolute',
  width: '100%',
  left: 0,
  top: 0
};

var renderIcon = function renderIcon(textElement) {
  if (textElement !== 'span') {
    _devLogger2.default.warn({
      message: 'UIAccordionItem: the `textElement` prop is no longer recommended ' + 'and may be removed in the future. Please use the `size` prop instead.',
      key: 'UIAccordionItem: use size prop'
    });
  }

  // To fix a bug in IE11 with extra space added to the SVG, this uses a
  // <canvas> element as a sibling to the SVG to work around it (detailed in
  // https://stackoverflow.com/a/30416241). Hack passed inline to keep this
  // more portable and keep the logic in the component vs. the stylesheet

  if (textElement === 'span') {
    return _react2.default.createElement(
      'div',
      { className: 'private-accordion__indicator' },
      _react2.default.createElement('canvas', {
        width: _IconConstants.CARET_WIDTH,
        height: _IconConstants.CARET_HEIGHT,
        style: indicatorCanvasStyle
      }),
      _react2.default.createElement(_UICaret2.default, {
        style: indicatorCaretStyle,
        viewBoxHeight: _IconConstants.CARET_HEIGHT,
        viewBoxWidth: _IconConstants.CARET_WIDTH,
        width: 12
      })
    );
  }

  return _react2.default.createElement(_UIIcon2.default, { className: 'private-accordion__indicator', name: 'right' });
};

var UIAccordionItem = function (_PureComponent) {
  _inherits(UIAccordionItem, _PureComponent);

  function UIAccordionItem(props) {
    _classCallCheck(this, UIAccordionItem);

    var _this = _possibleConstructorReturn(this, (UIAccordionItem.__proto__ || Object.getPrototypeOf(UIAccordionItem)).call(this, props));

    _this.state = {
      openComplete: props.open
    };
    _this.handleCloseStart = _this.handleCloseStart.bind(_this);
    _this.handleOpenComplete = _this.handleOpenComplete.bind(_this);
    _this.handleTitleClick = _this.handleTitleClick.bind(_this);
    return _this;
  }

  _createClass(UIAccordionItem, [{
    key: 'handleCloseStart',
    value: function handleCloseStart() {
      this.setState({ openComplete: false });
    }
  }, {
    key: 'handleOpenComplete',
    value: function handleOpenComplete() {
      this.setState({ openComplete: true });
    }
  }, {
    key: 'handleTitleClick',
    value: function handleTitleClick() {
      var _props = this.props,
          onOpenChange = _props.onOpenChange,
          open = _props.open;

      onOpenChange((0, _SyntheticEvent2.default)(!open));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          animate = _props2.animate,
          children = _props2.children,
          Content = _props2.Content,
          contentClassName = _props2.contentClassName,
          disabled = _props2.disabled,
          __onOpenChange = _props2.onOpenChange,
          open = _props2.open,
          size = _props2.size,
          textElement = _props2.textElement,
          title = _props2.title,
          titleClassName = _props2.titleClassName,
          rest = _objectWithoutProperties(_props2, ['animate', 'children', 'Content', 'contentClassName', 'disabled', 'onOpenChange', 'open', 'size', 'textElement', 'title', 'titleClassName']);

      var TextElement = textElement; // 'span' by default

      var computedTitleClassName = (0, _classNames2.default)(titleClassName, 'private-accordion', 'private-accordion--' + TShirtSize.fromProp(size).short, {
        'private-accordion--open': open,
        'private-accordion--legacy': textElement !== 'span'
      });

      return _react2.default.createElement(
        'div',
        rest,
        _react2.default.createElement(
          _UIClickable2.default,
          {
            'aria-expanded': open,
            className: computedTitleClassName,
            'data-open-complete': this.state.openComplete,
            disabled: disabled,
            onClick: this.handleTitleClick
          },
          _react2.default.createElement(
            TextElement,
            { className: 'private-accordion__text-wrapper' },
            renderIcon(textElement),
            title
          )
        ),
        _react2.default.createElement(
          _AccordionTransition2.default,
          {
            Content: Content,
            duration: animate ? undefined : 0,
            className: (0, _classNames2.default)('UIAccordionItem-content', 'private-accordion__content', contentClassName),
            onCloseStart: this.handleCloseStart,
            onOpenComplete: this.handleOpenComplete,
            open: open
          },
          children
        )
      );
    }
  }]);

  return UIAccordionItem;
}(_react.PureComponent);

UIAccordionItem.propTypes = {
  animate: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node,
  Content: _component2.default,
  contentClassName: _react.PropTypes.string,
  disabled: _react.PropTypes.bool.isRequired,
  onOpenChange: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  textElement: _component2.default,
  title: _react.PropTypes.node.isRequired,
  titleClassName: _react.PropTypes.string,
  size: TShirtSize.allSizes
};

UIAccordionItem.defaultProps = {
  animate: true,
  disabled: false,
  open: false,
  size: 'extra-small',
  textElement: 'span'
};

UIAccordionItem.displayName = 'UIAccordionItem';

exports.default = (0, _Controllable2.default)(UIAccordionItem, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/accordion/UIAccordionItem.js
// module id = 577
// module chunks = 171